import { SSR } from "../../common/apiUrl/ssr/ssrUrl";
import { API } from "../../common/model/objectTypes";
import { deliveredReturnInfo } from "../../utils/apiDescription/ssr/deliveredReturns";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { EFileFormsResponseBody, accessLinkResponseBody, deliveredReturnParameter, deliveredReturnResponseBody, requiredTaxReturnIdParameter, resendAccessLinkRequestBody, secondBaseRequestBody, sendReminderRequestBody, signatureStatusResponseBody, signersInfoResponseBody } from "../../utils/ssr/apiObjects";
import { accessLinkJsonRequestCurl, archiveReturnJsonRequestCurl, deleteReturnJsonRequestCurl, deliveredReturnJsonRequestCurl, eFileFormJsonRequestCurl, recallReturnJsonRequestCurl, resendAccessLinkJsonRequestCurl, sendReminderJsonRequestCurl, signatureStatusJsonRequestCurl, signerInfoJsonRequest } from "../../utils/ssr/sampleJsonRequest";
import { accessLinkJsonResponse, deliveredReturnsJsonResponse, eFileFormsJsonResponse, signatureStatusJsonResponse, signersInfoJsonResponse } from "../../utils/ssr/sampleJsonResponse";

const AccessLink : API = {
    name: "Access Link",
    url: `${API_BASE_URL}/${SSR.DELIVERED.ACCESS_LINK_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: deliveredReturnInfo.accessLink,
    requestBody: requiredTaxReturnIdParameter,
    responseBody: accessLinkResponseBody,
    jsonRequest: accessLinkJsonRequestCurl,
    jsonResponse: accessLinkJsonResponse,
}

const ArchiveReturn : API = {
    name: "Archive Return",
    url: `${API_BASE_URL}/${SSR.DELIVERED.ARCHIVE_RETURN_URL}`,
    method: "PUT",
    headers: requestHeaderWithCallback,
    apiInfo: deliveredReturnInfo.archiveReturn,
    requestBody: secondBaseRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: archiveReturnJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202)
}

const DeleteReturn : API = {
    name: "Delete Return",
    url: `${API_BASE_URL}/${SSR.DELIVERED.DELETE_RETURN_URL}`,
    method: "DEL",
    headers: requestHeaderWithCallback,
    apiInfo: deliveredReturnInfo.deleteReturn,
    requestBody: secondBaseRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: deleteReturnJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202)
}

const All : API = {
    name: "Delivered Return",
    url: `${API_BASE_URL}/${SSR.DELIVERED.DELIVERED_RETURN_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: deliveredReturnInfo.deliveredReturns,
    requestBody: deliveredReturnParameter,
    responseBody: deliveredReturnResponseBody,
    jsonRequest: deliveredReturnJsonRequestCurl,
    jsonResponse: deliveredReturnsJsonResponse
}

const EFileForm : API = {
    name: "E File Form",
    url: `${API_BASE_URL}/${SSR.DELIVERED.E_FILE_FORMS_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: deliveredReturnInfo.e_fileForms,
    requestBody: requiredTaxReturnIdParameter,
    responseBody: EFileFormsResponseBody,
    jsonRequest: eFileFormJsonRequestCurl,
    jsonResponse: eFileFormsJsonResponse
}

const RecallReturn : API = {
    name: "Recall Return",
    url: `${API_BASE_URL}/${SSR.DELIVERED.RECALL_RETURN_URL}`,
    method: "PUT",
    headers: requestHeaderWithCallback,
    apiInfo: deliveredReturnInfo.recallReturn,
    requestBody: secondBaseRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: recallReturnJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202)
}

const ResendAccessLink : API = {
    name: "Resend Access Link",
    url: `${API_BASE_URL}/${SSR.DELIVERED.RESEND_ACCESS_LINK_URL}`,
    method: "POST",
    headers: commonRequestHeader,
    apiInfo: deliveredReturnInfo.resendAccessLink,
    requestBody: resendAccessLinkRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: resendAccessLinkJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200)
}

const SendReminder : API = {
    name: "Send Reminder",
    url: `${API_BASE_URL}/${SSR.DELIVERED.SEND_REMINDER_URL}`,
    method: "POST",
    headers: commonRequestHeader,
    apiInfo: deliveredReturnInfo.sendReminder,
    requestBody: sendReminderRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: sendReminderJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200)
}

const SignatureStatus : API = {
    name: "Signature Status",
    url: `${API_BASE_URL}/${SSR.DELIVERED.SIGNATURE_STATUS_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: deliveredReturnInfo.signatureStatus,
    requestBody: requiredTaxReturnIdParameter,
    responseBody: signatureStatusResponseBody,
    jsonRequest: signatureStatusJsonRequestCurl,
    jsonResponse: signatureStatusJsonResponse
}

const SignersInfo : API = {
    name: "Signers Info",
    url: `${API_BASE_URL}/${SSR.DELIVERED.SIGNER_INFORMATION_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: deliveredReturnInfo.signerInformation,
    requestBody: requiredTaxReturnIdParameter,
    responseBody: signersInfoResponseBody,
    jsonRequest: signerInfoJsonRequest,
    jsonResponse: signersInfoJsonResponse
}

export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'All':
            return All;
        case 'Access Link':
            return AccessLink;
        case 'Archive':
            return ArchiveReturn;
        case 'Delivered Return':
            return DeleteReturn;
        case 'Efile Forms':
            return EFileForm;
        case 'Recall':
            return RecallReturn;
        case 'Resend Access Link':
            return ResendAccessLink;
        case 'Send Reminder':
            return SendReminder;
        case 'Signature Status':
            return SignatureStatus;
        case 'Signer Info':
            return SignersInfo;
    }
}